import { Tooltip, makeStyles } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { PricePerPersonDisclaimerTooltipText } from '../../../../constants';
import CallForPricing from '../../CallForPricing';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontFamily: 'var(--fontFamilyBody)',
  },
}));

const CostFromPrice = ({ price, label }) => {
  const classes = useStyles();
  return (
    <>
      {label && <span className="inline sm:hidden">{label} from : </span>}
      {!!price && (
        <Tooltip title={PricePerPersonDisclaimerTooltipText} arrow classes={classes}>
          <NumberFormat
            value={price}
            displayType="text"
            thousandSeparator
            prefix="$"
            decimalScale={0}
          />
        </Tooltip>
      )}
      {!price && <CallForPricing />}
    </>
  );
};

CostFromPrice.propTypes = {
  price: PropTypes.number,
  label: PropTypes.string,
};

CostFromPrice.defaultProps = {
  price: undefined,
  label: undefined,
};

export default CostFromPrice;
